let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ivRR1")).then(() => parcelRequire('7Gs2S'));